export enum WelcomePackStepEnum {
  landing = 'LANDING',
  idBadge = 'ID_BADGE',
  orderUniform = 'ORDER_UNIFORM',
  quickNurse = 'QUICK_NURSE',
  bookFirstShift = 'BOOK_FIRST_SHIFT',
  timesheetsPayroll = 'TIMESHEET_AND_PAYROLL',
  payRates = 'PAY_RATES',
  contactUs = 'CONTACT_US',
  advanceShifts = 'ADVANCE_SHIFTS',
  agencyNurseHandbook = 'AGENCY_NURSE_HANDBOOK',

  error = 'ERROR',
  finished = 'FINISH',
}

export interface WelcomePackStatusStepHttpModel {
  name: WelcomePackStepEnum;
  number: number;
}

export interface WelcomePackStatusHttpModel {
  currentStep: WelcomePackStepEnum | null;
  isCompleted: boolean;
  steps: Array<WelcomePackStatusStepHttpModel>;
}

export interface WelcomePackAvailableShift {
  when: string;
  where: string;
  location: string;
  time: string;
  dayTime: 'day' | 'night';
  type: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  typeIcon: any; //todo fix icons (parent todo)
  link: string;
}
